import listActions from 'src/modules/employeeCategory/list/employeeCategoryListActions';
import EmployeeCategoryService from 'src/modules/employeeCategory/employeeCategoryService';
import Errors from 'src/modules/shared/error/errors';
import {i18n} from 'src/i18n';
import {getHistory} from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'EMPLOYEE_CATEGORY_DESTROY';

const employeeCategoryDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,
  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({type: employeeCategoryDestroyActions.DESTROY_STARTED});
      await EmployeeCategoryService.destroyAll([id]);
      dispatch({type: employeeCategoryDestroyActions.DESTROY_SUCCESS});
      Message.success(i18n('entities.employeeCategory.destroy.success'));
      dispatch(listActions.doFetchCurrentFilter());
      getHistory().push('/employee-category');
    } catch (error) {
      Errors.handle(error);
      dispatch(listActions.doFetchCurrentFilter());
      dispatch({type: employeeCategoryDestroyActions.DESTROY_ERROR});
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({type: employeeCategoryDestroyActions.DESTROY_ALL_STARTED});
      await EmployeeCategoryService.destroyAll(ids);
      dispatch({type: employeeCategoryDestroyActions.DESTROY_ALL_SUCCESS});
      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }
      Message.success(i18n('entities.employeeCategory.destroyAll.success'));
      getHistory().push('/employee-category');
    } catch (error) {
      Errors.handle(error);
      dispatch(listActions.doFetchCurrentFilter());
      dispatch({type: employeeCategoryDestroyActions.DESTROY_ALL_ERROR});
    }
  },
};

export default employeeCategoryDestroyActions;
